import React, { useState } from "react";
import { FormValues, BulkMessageSendFilterType } from "./types";
import { useFormContext } from "react-hook-form";
import { CsvUpload } from "./CsvUpload";
import { StudentFilters } from "./BasicInformationPage/StudentFilters";
import { RiseActionSend } from "./RiseActionSend";

export const BasicInformationPage = () => {
  const { getValues } = useFormContext<FormValues>();
  let initFilterType: BulkMessageSendFilterType = "studentFilters";

  const riseActionId = getValues("filters.riseActionId");

  if (riseActionId) initFilterType = "riseActionSend";
  else if (getValues("filters.userIds")?.length) initFilterType = "csvImport";

  const [filterType, setFilterType] =
    useState<BulkMessageSendFilterType>(initFilterType);

  return (
    <div className="flex flex-col">
      {(() => {
        if (filterType === "riseActionSend") {
          return (
            <RiseActionSend
              filterType={filterType}
              setFilterType={setFilterType}
            />
          );
        } else if (filterType === "csvImport") {
          return (
            <CsvUpload filterType={filterType} setFilterType={setFilterType} />
          );
        } else {
          return (
            <StudentFilters
              filterType={filterType}
              setFilterType={setFilterType}
            />
          );
        }
      })()}
    </div>
  );
};
